import React from 'react';
import { Modal } from 'antd';

interface ModalDeleteProps {
  isOpen: boolean;
  onOk: () => void;
  onCancel: () => void;
  content: string;
  okText?: string;
  cancelText?: string;
}

const ModalDelete: React.FC<ModalDeleteProps> = ({
  isOpen,
  onOk,
  onCancel,
  content,
  okText = '確認',
  cancelText = 'キャンセル',
}) => {
  return (
    <Modal
      className="modal-delete"
      closable={false}
      open={isOpen}
      onOk={onOk}
      onCancel={onCancel}
      okText={okText}
      cancelText={cancelText}
      style={{ top: '35%' }}
    >
      <p>{content}</p>
    </Modal>
  );
};

export default ModalDelete;
